module.exports = __webpack_public_path__ + "img/icon_blue-small_pin-location.7c2ae945.svg";